export default __webpack_public_path__ + "static/media/27.733e9c9e.png";